import { client } from '../../../../services/apiClient';
import { PROJECTS_ENDPOINT } from '../../../../services/projects/ProjectService';

const PROJECT_OPTIONS_ENDPOINT = `${PROJECTS_ENDPOINT}/options`;

export const updateProjectKeywords = async (projectId: number, keywords: string[]): Promise<boolean> => {
  const { data } = await client(true, true).post<boolean>(
    `${PROJECT_OPTIONS_ENDPOINT}/keywords/${projectId}`,
    { keywords }
  );
  return data;
};

export const updateProjectDomains = async (projectId: number, domains: string[]): Promise<boolean> => {
  const { data } = await client(true, true).post<boolean>(
    `${PROJECT_OPTIONS_ENDPOINT}/domains/${projectId}`,
    {
      domains,
    }
  );
  return data;
};

export const getProjectKeywords = async (projectId: number): Promise<string[]> => {
  const { data } = await client(true, true).get<string[]>(
    `${PROJECT_OPTIONS_ENDPOINT}/keywords/${projectId}`
  );
  return data;
};

export const getProjectDomains = async (projectId: number): Promise<string[]> => {
  const { data } = await client(true, true).get<string[]>(
    `${PROJECT_OPTIONS_ENDPOINT}/domains/${projectId}`
  );
  return data;
};
